import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import CodeIcon from '@mui/icons-material/Code';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
// import DashboardIcon from '@mui/icons-material/Dashboard';
import EngineeringIcon from '@mui/icons-material/Engineering';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Header from '../Header.jsx';
import useMediaQuery from '@mui/material/useMediaQuery';
import "./NavDrawer.css";

const drawerWidth = 230;

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
});

const closedMixin = (theme) => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: `calc(${theme.spacing(7)} + 1px)`,
    [theme.breakpoints.up('sm')]: {
        width: `calc(${theme.spacing(8)} + 1px)`,
    },
});

const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme),
    }),
}));

function NavDrawer() {
    const isMobile = useMediaQuery('(max-width:600px)');

    const [open, setOpen] = React.useState(isMobile ? false : true);
    const [path, setPath] = React.useState({ practicePath: "", attendancePath: "",notesPath:"" })
    const navigate = useNavigate();
    const location = useLocation();

    React.useEffect(() => {
        let updatedPracticePath = localStorage.getItem('practicePath') || '/learner/labdailypractices';
        let updatedAttendancePath = JSON.parse(localStorage.getItem('attendancePath'))?.attendancePath || '/learner/attendance';
        let updatedNotesPath = localStorage.getItem('notesPath') || '/learner/dailynotes';


        if (location.pathname === '/learner/labdailypractices') {
            updatedPracticePath = '/learner/labdailypractices';
        }      
        if (location.pathname === '/learner/attendance') {
            updatedAttendancePath = '/learner/attendance';
        }
        if (location.pathname === '/learner/dailynotes') {
            updatedNotesPath = '/learner/dailynotes';
        }
        setPath((prev) => ({
            ...prev,
            attendancePath:updatedAttendancePath,
            practicePath: updatedPracticePath,
            notesPath: updatedNotesPath,
        }));
    }, [location.pathname]); 

    const menuItems = React.useMemo(() => [
        { label: ' Attendance', icon: <PersonAddAlt1Icon />, path: path?.attendancePath },
        { label: 'Today\'s Practice', icon: <EngineeringIcon />, path: path?.practicePath },
        { label: 'All Coding Practices', icon: <CodeIcon />, path: '/learner/all-coding-practices' },
        { label: 'All Topics', icon: <EngineeringIcon />, path: '/learner/all-topics' },
        // localStorage.getItem('notesPath')&&{ label: ' Practice Notes', icon: <EngineeringIcon />, path: path?.notesPath },
       // { label: 'Learner Dashboard', icon: <DashboardIcon />, path: '/learner/learner-dashboard' },
    ], [path]);
    const handleDrawer = () => setOpen(!open);
    const handleTabClick = (path) => {
        navigate(path);
        if (isMobile) {
            setOpen(false);
        }
    };

    return (
        <>
            <Header handleDrawer={handleDrawer} />
            <Box className='Box1' sx={{ display: 'flex' }}>
                {isMobile ? (
                    <MuiDrawer
                        variant="temporary"
                        anchor="left"
                        open={open}
                        onClose={handleDrawer}
                        ModalProps={{
                            keepMounted: true,
                        }}
                        sx={{
                            '& .MuiDrawer-paper': { width: drawerWidth, position: 'absolute', marginTop: "60px !important" },
                        }}
                    >
                        <List>
                            {menuItems.map((item) => (
                                <ListItem key={item.label} disablePadding>
                                    <ListItemButton
                                        className={`nav-item nav-smallScreen ${location.pathname === item.path ? 'active' : ''}`}
                                        onClick={() => handleTabClick(item.path)}
                                    >
                                        <ListItemIcon sx={{ color: `${location.pathname === item.path && '#fff'}` }}>
                                            {item.icon}
                                        </ListItemIcon>
                                        <ListItemText primary={item.label} />
                                    </ListItemButton>
                                </ListItem>
                            ))}
                        </List>
                    </MuiDrawer>
                ) : (
                    <Drawer variant="permanent" open={open}>
                        <List>
                            {menuItems?.map((item) => (
                                <ListItem key={item?.label} disablePadding sx={{ display: 'block' }}>
                                    <Tooltip title={open ? '' : item?.label} placement="right" arrow>
                                        <ListItemButton
                                            className={`nav-item ${location.pathname === item?.path ? 'active' : ''}`}
                                            onClick={() => handleTabClick(item?.path)}
                                        >
                                            <ListItemIcon sx={{ minWidth: 0, mr: open ? 3 : 'auto', justifyContent: 'center', color: `${location.pathname === item?.path && '#fff'}` }}>
                                                {item?.icon}
                                            </ListItemIcon>
                                            <ListItemText primary={item?.label} sx={{ opacity: open ? 1 : 0 }} />
                                        </ListItemButton>
                                    </Tooltip>
                                </ListItem>
                            ))}
                        </List>
                    </Drawer>
                )}
                <Box component="main" sx={{ p: 3 }} className='outlet-box'>
                    <Outlet />
                </Box>
            </Box>
        </>
    );
}

export default NavDrawer;
